// Validates textbox input
export const isValidForm = (limitEntriesToNumbers: boolean | undefined, val: string) =>
  !limitEntriesToNumbers || !isNaN(Number(val));
